import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Drevo za dva",
  "description": "",
  "published": "2007-04-12T00:00:00.000Z",
  "redirect_from": ["/blog/drevo-za-dva/swizec/232"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pogosto so rezultati študijskih filmov pomankljivi na veÄ frontah. To se navadno da pripisati nizkemu proraÄunu in neizkušenosti ustvarjalcev. Enkrat ali dvakrat sem bil na nekakšni predstavitvi amaterskih filmov in po dveh urah sem mislil, da si bom raje izkljuval oÄi, kot še naprej trpel v pokolu slabega igranja in pisanja.`}</p>
    <p>{`VÄasih pa nastanejo stvari, kot jo je ustvaril Joel Furtado v filmnÄku `}<a parentName="p" {...{
        "href": "http://joelfurtado.com/"
      }}>{`Tree for two`}</a>{`. Pravi, da je produkcija 6 minutne 3D animacije trajala osem mesecev od koncepta do konÄanega videa in mislim, da se je popolnoma izplaÄalo. Gibanje, z izjemo pasje spodnje Äeljusti, je tako naravno, da kar pozabiš, da vse skupaj ni narejeno z najnovejšimi animacijskimi tehnikami, ki jih uporablja Hollywood.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      